import { styled, useAssetsPath } from '@obvio/app'
import { SvgDownload } from '@obvio/svg'
import { Stack } from '@obvio/ui'

import type { ReactElement } from 'react'

type FileProps = {
  files: string[]
}

const Wrap = styled.a`
  padding-top: ${(theme) => theme.spacing.medium};
  padding-bottom: ${(theme) => theme.spacing.small};
  width: 80%;
  border-top: 1px solid ${(theme) => theme.stroke};
`

const CenterStack = styled(Stack)`
  align-items: center;
  color: black;
  overflow: hidden;
  width: 100%;
  display: flex;
  justify-content: space-between;
`
const StackEnd = styled(Stack)`
  justify-content: flex-end;
  height: 100%;
  font-size: 0.8125rem;
  font-weight: 300;
  line-height: 150%;
`

const FileName = styled.span`
  flex: 1;
  ${(theme) => theme.truncate}
`

const getFileName = (file: string): string => {
  const path = file.split('/')
  return path[path.length - 1]
}

export function Files({ files }: FileProps): ReactElement {
  const path = useAssetsPath()
  return (
    <StackEnd kind="vertical">
      {files.map((src) => {
        const name = getFileName(src)

        return (
          <Wrap key={src} href={`${path}/${src}`} target="_blank">
            <CenterStack>
              <FileName>{name}</FileName>
              <SvgDownload />
            </CenterStack>
          </Wrap>
        )
      })}
    </StackEnd>
  )
}
